import {
  formatChartValueWithShare,
  getChartItemColor,
  getChartValuesShares,
} from '../Chart.utils'

export function getChartDonutShares({ items, total }) {
  return getChartValuesShares(
    items.map(item => item.value),
    total
  )
}

export function getChartDonutLegendItems({ colors, items, nameKey, shares }) {
  return items.map((item, index) => ({
    color: getChartItemColor({ colors, index, item }),
    id: item.id ?? item[nameKey],
    label: `${item[nameKey]} (${item.value})`,
    value: `${shares[index]}%`,
  }))
}

export function getChartDonutActiveItemValue({
  activeItem,
  items,
  nameKey,
  shares,
}) {
  return formatChartValueWithShare({
    share:
      shares[items.findIndex(item => item[nameKey] === activeItem[nameKey])],
    value: activeItem.value,
  })
}
